import { render, staticRenderFns } from "./subTab3.vue?vue&type=template&id=6c18eb28&scoped=true"
import script from "./subTab3.vue?vue&type=script&lang=js"
export * from "./subTab3.vue?vue&type=script&lang=js"
import style0 from "./subTab3.vue?vue&type=style&index=0&id=6c18eb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c18eb28",
  null
  
)

export default component.exports